import React, { useState, useRef, useEffect } from 'react';

type ChatInputProps = {
  onSend: (message: string) => void;
  placeholder?: string;
  disabled?: boolean; // ⬅️ new prop
  borderRadius?: boolean
};

const ChatInput: React.FC<ChatInputProps> = ({
  onSend,
  placeholder = 'Type your message...',
  disabled = false,
  borderRadius
}) => {
  const [value, setValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const sendMessage = () => {
    const trimmed = value.trim();
    if (trimmed && !disabled) {
      onSend(trimmed);
      setValue('');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        padding: '12px',
        borderTop: '1px solid #ddd',
        backgroundColor: '#fff',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        borderRadius: borderRadius ? '20px' : '0px'
      }}
    >
      <textarea
        ref={textareaRef}
        value={value}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={1}
        disabled={disabled} // ⬅️ disabled textarea
        style={{
          flex: 1,
          resize: 'none',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '10px 12px',
          outline: 'none',
          minHeight: '40px',
          maxHeight: '150px',
          overflowY: 'auto',
          marginRight: '8px',
          fontFamily: 'Montserrat',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          backgroundColor: disabled ? '#f2f2f2' : '#fff',
          cursor: disabled ? 'not-allowed' : 'text',
        }}
      />
      <button
        onClick={sendMessage}
        disabled={disabled} // ⬅️ disabled button
        style={{
          backgroundColor: disabled ? '#ccc' : 'var(--primary)',
          color: '#fff',
          border: 'none',
          padding: '10px 16px',
          borderRadius: '8px',
          fontSize: '16px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          fontFamily: 'Montserrat',
          fontWeight: 400,
          lineHeight: '24px',
        }}
      >
        Send
      </button>
    </div>
  );
};

export default ChatInput;
